<template>
    <b-notification type="is-warning" has-icon>
        This is the GW2Scratch.Economics version, which is work in progress.
    </b-notification>
</template>

<script>
    export default {
        name: "EconomicsWarning"
    }
</script>

<style scoped>

</style>